'use client';

import { useState } from 'react';
import BaseLayout from '../layouts/BaseLayout';
import Image from 'next/image';

export default function HowToAttributePage() {
  const [copied, setCopied] = useState(false);

  const handleCopyHTML = () => {
    const attributionHTML = `<a href="https://davooda.com" target="_blank" rel="noopener">Icons</a> by <a href="https://davooda.com" target="_blank" rel="noopener">davooda.com</a>`;
    navigator.clipboard.writeText(attributionHTML).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  };

  return (
    <BaseLayout
      title="How To Attribute"
      description="Learn how to properly credit the icon creator."
      showHeader={true}
    >
      <div className="max-w-7xl w-[90%] mx-auto pt-24 mt-8">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start mb-20">
          {/* Left Content */}
          <div className="w-full md:w-1/2 md:pr-8 mb-8 md:mb-0">
            <h1 className="text-5xl font-bold mb-6 leading-tight text-gray-800">
              How To Attribute
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              If you use our icons for free, you must show credit to the creator. Copy the code below and include it where you use the icons.
            </p>
            <button
              onClick={handleCopyHTML}
              style={{ width: "240px" }}
              className={`inline-flex items-center px-5 py-3 border border-gray-800 rounded-lg font-semibold text-base transition-all duration-300 ${
                copied 
                  ? 'bg-green-500 text-white border-green-500' 
                  : 'hover:bg-gray-800 hover:text-white'
              }`}
            >
              {copied ? 'Copied!' : 'Icons by davooda.com'}
              {!copied && (
                <Image
                  src="/images/copy.svg"
                  alt="Copy"
                  width={16}
                  height={16}
                  className="ml-2"
                />
              )}
            </button>
          </div>
          
          {/* Right Image */}
          <div className="w-full md:w-1/2 md:pl-8 flex justify-end">
            <Image
              src="/images/attribution3.png"
              alt="Attribution illustration"
              width={500}
              height={350}
              className="rounded-xl w-full h-auto"
            />
          </div>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div>
            <h3 className="text-2xl font-semibold mb-4">Websites</h3>
            <p className="text-gray-700">
              On your website, show "Icons by davooda.com" near the icon or in the site's footer.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">Printed Products</h3>
            <p className="text-gray-700">
              In printed materials, include "Icons by davooda.com" in the acknowledgments section.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">Apps/Games</h3>
            <p className="text-gray-700">
              In apps or games, add "Icons by davooda.com" to the credits screen or app store listing.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">YouTube Videos</h3>
            <p className="text-gray-700">
              In YouTube videos, put "Icons by davooda.com" in the video description.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">Movies</h3>
            <p className="text-gray-700">
              In movies, include "Icons by davooda.com" in the film credits.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">Social Networks</h3>
            <p className="text-gray-700">
              On social media, mention "Icons by @davooda" in your posts.
            </p>
          </div>
        </div>

        {/* Attribution Offer */}
        <div className="bg-sky-50 py-12 px-8 rounded-lg text-center mb-16">
          <h2 className="text-3xl font-bold mb-6">Don't Want to Include Attribution?</h2>
          <p className="text-lg text-gray-700 max-w-xl mx-auto">
            Purchase an SVG license to use the icons without giving credit.
          </p>
        </div>
      </div>
    </BaseLayout>
  );
}